import React from "react";
import { Field, FieldProps } from "formik";
import { Input } from "@sonder/ui/source/styled/fragments/Input";
import { InputField } from "@sonder/ui/source/styled/fragments/InputField";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { ValidationException } from "@sonder/ui/source/styled/fragments/ValidationException";
import { ValidationFn } from "core/validations";

interface FormikInputFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  validate?: ValidationFn;
}

export const FormikInputField = ({
  label,
  name,
  validate,
  ...rest
}: FormikInputFieldProps) => (
  <InputField>
    <Field name={name} validate={validate}>
      {({ field, meta }: FieldProps) => (
        <>
          {label && <Label>{label}</Label>}
          <Input {...rest} {...field} />
          {meta.touched && meta.error && (
            <ValidationException>{meta.error}</ValidationException>
          )}
        </>
      )}
    </Field>
  </InputField>
);
